import React from "react";
import {Person} from "../../../services/interface/query/person";
import Vehicles from "./Vehicles";
import CorporateInvestments from "./CorporateInvestments";
import PropertiesList from "./PropertiesList";

interface Props {
    person?: Person;
}

export default function Properties({person}: Props) {
    return (
        <div className={'flex flex-col gap-3'}>
            <CorporateInvestments {...{person}}/>
            <PropertiesList {...{person}}/>
            <Vehicles {...{person}}/>
        </div>
    )
}
